module.exports = __webpack_public_path__ + "img/img24.8386378a.png";